// spec 56 v8 §9, §10 (D87 b, D100 a): the product page's buy box and its floating bar follow the cart - the buy box's
// pill "W koszyku: N" and the photo sticker, the bar's desktop pill and phone link - from an add's answer and a restored
// page, through product-form.js's one registry. One marker serves both (the registry's count on a product page is 2).
// Loaded once, by code-zestawy-main. whenDefined's resolved value is not relied on (browser-dependent): the class is
// taken back by name.
customElements.whenDefined("product-form").then(() => {
  // Gate 2: a cart control about to go (a snapshot of a cart without the product hides the pill and unlinks the phone
  // column; a hidden or href-less control takes no focus) hands the focus it holds to its scope's add first. Focus
  // anywhere else stays where it is
  const handOff = (control, add) => {
    if (control && add && control.contains(document.activeElement)) add.focus({ preventScroll: true });
  };
  // a pill (the buy box's or the bar's): the words and the name from its templates while in the cart, hidden otherwise
  const paint = (pill, quantity, add) => {
    const words = pill && pill.querySelector(".product-buy__words, .product-bar__words");
    if (!pill || !words) return;
    if (quantity > 0) {
      words.textContent = pill.dataset.words.replace("[quantity]", String(quantity));
      pill.setAttribute("aria-label", pill.dataset.name.replace("[quantity]", String(quantity)));
    } else {
      handOff(pill, add);
    }
    pill.hidden = quantity === 0;
  };
  // the bar's phone column: a link only in the cart (an <a> without href is no link and takes no focus); the price gives
  // way to the line "W koszyku: N" with the arrow. The desktop price is always shown and is not touched
  const paintPhone = (bar, quantity, add) => {
    const column = bar.querySelector(".product-bar__info--phone");
    const price = column && column.querySelector(".product-bar__price");
    const line = column && column.querySelector(".product-bar__line");
    const words = line && line.querySelector(".product-bar__words");
    if (!price || !line || !words) return;
    if (quantity > 0) {
      words.textContent = column.dataset.words.replace("[quantity]", String(quantity));
      column.setAttribute("href", column.dataset.href);
      column.setAttribute("aria-label", column.dataset.name.replace("[quantity]", String(quantity)));
    } else {
      handOff(column, add);
      column.removeAttribute("href");
      column.removeAttribute("aria-label");
    }
    price.hidden = quantity > 0;
    line.hidden = quantity === 0;
  };
  customElements.get("product-form").marks.push({
    apply(lines, { snapshot = false } = {}) {
      for (const scope of document.querySelectorAll(".product-buy[data-product-id], product-bar[data-product-id]")) {
        const id = Number(scope.dataset.productId);
        if (!Number.isInteger(id) || (!lines.has(id) && !snapshot)) continue;
        const quantity = lines.get(id) || 0;
        if (scope.localName === "product-bar") {
          // the bar's own add while the bar is shown (product.css's condition, read from the attributes it keys on),
          // else the buy box's (product-bar.js's coral: the first submit of the form the bar's add submits). F492: no
          // :has() in matches() (it throws in Firefox 98-120)
          const own = scope.querySelector(".product-bar__add");
          const coral = own && own.form && own.form.querySelector('[type="submit"]');
          const shown =
            scope.matches("[data-above], [data-held]") ||
            Boolean(scope.querySelector(".product-bar__message:not([hidden])"));
          const add = shown ? own : coral;
          paint(scope.querySelector(".product-bar__cart"), quantity, add);
          paintPhone(scope, quantity, add);
          continue;
        }
        paint(scope.querySelector(".product-buy__cart"), quantity, scope.querySelector(".product-form__submit"));
        const main = scope.closest("#MainProduct");
        const sticker = main && main.querySelector(".product-media__sticker");
        if (sticker) sticker.hidden = quantity === 0;
      }
    },
  });
});
